module.exports = Phaser;


//////////////////
// WEBPACK FOOTER
// external "Phaser"
// module id = 3
// module chunks = 0